import { ExternalSensorType } from '@/../client-generator/generated-clients/device-settings';
import { Options } from 'vue-class-component';
import DeviceSettingsComponent from '../DeviceSettingsComponent';

@Options({
  name: 'ThermoProbeSettings',
})
export default class ThermoProbeSettings extends DeviceSettingsComponent {
  ExternalSensorType = ExternalSensorType;

  get settings() {
    return this.defaultSettings.thermoProbeSettings;
  }
}
